import { memo, useCallback, useEffect } from "react";
import AuthorizationModal from "src/generator/_Modals/AuthorizationModal/AuthorizationModal";
import { mapUsers } from "src/generator/utils/mapUsers";
import { useGetApi, usePostApi } from "src/hooks";
import { type ICredentials } from "src/interfaces";
import { type IUser } from "src/components/shared/UserList/UserList.types";
import { getUserId, getYachtId } from "src/utils";
import { refreshLogoutTimer } from "src/generator/utils/refreshLogoutTimer";

interface Props {
  opened: boolean;
  close: () => void;
}

const mapper = (data: { data?: IUser[] }) => {
  if (data?.data && Array.isArray(data.data)) {
    return mapUsers(data.data, "", "role firstname surname");
  }
  return [];
};

const LogoutModal = ({ opened, close }: Props) => {
  const { post, isLoading } = usePostApi();

  const { data: users, refetch: fetchUsers } = useGetApi({
    request: "re-auth-users",
    body: { params: { userid: getUserId(), yachtid: getYachtId() } },
    fetchOnInit: false,
    mapper,
  });

  useEffect(() => {
    if (opened) {
      void fetchUsers();
    }
  }, [opened, fetchUsers]);

  const handleSubmit = useCallback(
    async ({ pass, userid }: ICredentials) => {
      await post({
        request: "re-auth",
        body: { params: { pass, userid } },
        onSuccess: () => {
          close();
          refreshLogoutTimer();
        },
      });
    },
    [close, post],
  );

  return (
    <AuthorizationModal
      opened={!!(opened && users)}
      close={close}
      users={users ?? []}
      onSubmit={handleSubmit}
      loading={isLoading}
      logout
    />
  );
};

export default memo(LogoutModal);
